/**
 * Primary nav preview image: exactly one `nav-primary__link--media-pin` (JS) steuert,
 * welches Vorschaubild sichtbar bleibt, bis ein anderer Eintrag gewählt wird.
 * (Früher „peek“ für Hover-Transition — entfernt, damit der Text beim Verlassen sofort gedimmt wird.)
 */
var MEDIA_PIN_CLASS = 'nav-primary__link--media-pin';
var getNavLinks = function (nav) {
    return Array.from(nav.querySelectorAll('ul li > a[href]'));
};
var getItemMedia = function (anchor) { var _a, _b; return (_b = (_a = anchor.closest('li')) === null || _a === void 0 ? void 0 : _a.querySelector('.nav-primary__item-media')) !== null && _b !== void 0 ? _b : null; };
var getDefaultPinnedAnchor = function (nav) {
    var _a;
    var links = getNavLinks(nav);
    for (var _i = 0, links_1 = links; _i < links_1.length; _i++) {
        var anchor = links_1[_i];
        if (getItemMedia(anchor)) {
            return anchor;
        }
    }
    return (_a = links[0]) !== null && _a !== void 0 ? _a : null;
};
var setMediaPin = function (nav, anchor) {
    for (var _i = 0, _a = getNavLinks(nav); _i < _a.length; _i++) {
        var a = _a[_i];
        a.classList.remove(MEDIA_PIN_CLASS);
    }
    anchor === null || anchor === void 0 ? void 0 : anchor.classList.add(MEDIA_PIN_CLASS);
};
var initNavPrimaryPeek = function () {
    var nav = document.querySelector('#primary-navigation');
    if (!nav) {
        return;
    }
    var resetPinToDefault = function () {
        if (!nav.classList.contains('open')) {
            return;
        }
        setMediaPin(nav, getDefaultPinnedAnchor(nav));
    };
    resetPinToDefault();
    var openObserver = new MutationObserver(function () {
        resetPinToDefault();
    });
    openObserver.observe(nav, { attributes: true, attributeFilter: ['class'] });
    var links = getNavLinks(nav);
    var _loop_1 = function (anchor) {
        anchor.addEventListener('pointerenter', function () {
            setMediaPin(nav, anchor);
        });
        anchor.addEventListener('focusin', function () {
            setMediaPin(nav, anchor);
        });
    };
    for (var _i = 0, links_2 = links; _i < links_2.length; _i++) {
        var anchor = links_2[_i];
        _loop_1(anchor);
    }
};
export default initNavPrimaryPeek;
